// extracted by mini-css-extract-plugin
module.exports = {"block":"SoftballScores_block__byiJD","viewAll":"SoftballScores_viewAll__9dCYA"};